import React from "react";
import { useSelector } from "react-redux";
import WidgetCarouselCard from "../../features/widget/widgetCarouselCard/WidgetCarouselCard";
import pathRouts from "../../../enums/pathRoute";
import finalProjectImg from "../../../../assests/carouselWidget/finalProject.png";

const FinalProjectCarouselWidget = () => {

    const { texts } = useSelector(state => state.translate);

    return (
        <WidgetCarouselCard
            color="#B5267E"
            titleColor="#fff"
            title={texts.finalProjects}
            image={finalProjectImg}
            imageAlt={texts.finalProjects}
            link={`/${pathRouts.FINALPROJECTS}`}
        />
    );
};

export default FinalProjectCarouselWidget;
